import { render } from "./ImageModal.vue?vue&type=template&id=bf28fc4c&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"

import "./ImageModal.vue?vue&type=style&index=0&id=bf28fc4c&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf28fc4c"]])

export default __exports__